var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(!_vm.maintenance)?_c('Index',{attrs:{"api":_vm.apiUrl}}):_c('Maintenance')],1)}
var staticRenderFns = []

export { render, staticRenderFns }